if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))

	$('.sym-slides').slick()

	//accordion module

	const tabAccordionElement = [...document.getElementsByClassName('js-title-toggle')] || []
	const contentAccordionElement = [...document.getElementsByClassName('js-info-toggle')] || []

	tabAccordionElement.forEach(function (elementTab) {
		elementTab.addEventListener('click', function () {
			const clickedElement = this
			clickedElement.classList.toggle('change-icon')
			tabAccordionElement.forEach(function (elementClass) {
				if (elementClass !== clickedElement) elementClass.classList.remove('change-icon')
			})
			contentAccordionElement.forEach(function (elementContent) {
				let dataElementTab = elementTab.dataset.expand
				let dataElementContent = elementContent.dataset.expand

				elementContent.classList.add('info-toggle')

				if (elementTab.classList.contains('change-icon')) {
					if (dataElementTab === dataElementContent) {
						elementContent.classList.remove('info-toggle')
					}
				} else {
					if (dataElementTab === dataElementContent) {
						elementContent.classList.add('info-toggle')
					}
				}
			})
		})
	})

	let videoUrl
	$('.open-video').click(function (event) {
		event.preventDefault()
		videoUrl = $(this).attr('data-video')
		smallVideo = $(this).attr('data-small')
	})
	$('.open-video').fancybox({
		afterShow: function () {
			$('#lightbox-video').attr('src', videoUrl)
			$('#lightbox-video')[0].play()
		},
		overlayShow: true,
		centerOnScroll: true,
		speedIn: 100,
		speedOut: 50,
		allowfullscreen: true,
		width: '100%',
		height: '100%',
		autosize: false,
	})

	// animation to hash
	function animationToSearch() {
		if (window.location.search) {
			let params = window.location.search.slice(1)
			let post = params.split('=')[1]

			if (!post) return

			let target = document.querySelector(`#post-${post}`)
			if (target === null) return

			let onOffsetTop = target.offsetTop - 120

			window.scrollTo({
				top: onOffsetTop,
				behavior: 'smooth',
			})

			setTimeout(() => {
				let clicTarget = target.querySelector('[data-tb-click]')
				if (clicTarget !== null) {
					clicTarget.click()
				}
			}, 800)
		}
	}

	// init functions
	animationToSearch();

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

	//for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

})()


